import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { serviceOrderService } from '../../services/serviceOrderService';
import ServiceOrderForm from '../../components/ServiceOrders/ServiceOrderForm';
import Toast from '../../components/Common/Toast';

const EditServiceOrder = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState({ isOpen: false, message: '', type: 'info' });

  useEffect(() => {
    const loadOrder = async () => {
      try {
        console.log('📡 [EditServiceOrder] Cargando orden ID:', id);
        const response = await serviceOrderService.getServiceOrder(id);
        
        if (response.success && response.data) {
          console.log('✅ [EditServiceOrder] Orden cargada:', response.data);
          setOrder({ ...response.data, id: parseInt(id) });
        } else {
          console.warn('⚠️ [EditServiceOrder] Orden no encontrada');
          setToast({
            isOpen: true,
            message: 'Orden de servicio no encontrada',
            type: 'error'
          });
          setTimeout(() => {
            navigate('/service-orders');
          }, 2000);
        }
      } catch (error) {
        console.error('❌ [EditServiceOrder] Error al cargar orden:', error);
        setToast({
          isOpen: true,
          message: error.message || 'Error al cargar la orden de servicio',
          type: 'error'
        });
        setTimeout(() => {
          navigate('/service-orders');
        }, 2000);
      } finally {
        setLoading(false);
      }
    };

    if (id) {
      loadOrder();
    }
  }, [id, navigate]);

  const handleSuccess = () => {
    setToast({
      isOpen: true,
      message: 'Orden de servicio actualizada exitosamente',
      type: 'success'
    });
    setTimeout(() => {
      navigate('/service-orders');
    }, 1500);
  };

  const handleCancel = () => {
    navigate('/service-orders');
  };

  if (loading) {
    return (
      <div className="p-6">
        <div className="max-w-5xl mx-auto">
          <div className="text-center py-12">
            <div className="text-gray-500">Cargando...</div>
          </div>
        </div>
      </div>
    );
  }

  if (!order) {
    return null;
  }

  return (
    <div className="p-6">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-800">Editar Orden de Servicio</h1>
          <p className="text-gray-600 mt-1">Modifique la información de la orden de servicio</p>
          <div className="mt-2">
            <span className="text-sm font-mono text-teal-600">Código: {order.code}</span>
          </div>
        </div>

        {/* Formulario */}
        <ServiceOrderForm
          isOpen={true}
          onClose={handleCancel}
          order={order}
          onSuccess={handleSuccess}
          isPageMode={true}
        />

        {/* Toast de notificaciones */}
        <Toast
          isOpen={toast.isOpen}
          message={toast.message}
          type={toast.type}
          onClose={() => setToast({ ...toast, isOpen: false })}
        />
      </div>
    </div>
  );
};

export default EditServiceOrder;



